import { fetchCosts } from '../../../services/api/finance';
import { naturalCompare } from '../../../helpers';

function getTableValue(request, key) {
    switch (key) {
        default:
            return request[key];
    }
}

export const costs = {
    namespaced: true,
    state: {
        display: 10,
        page: 1,
        sort: {
            column: 'datetime',
            order: 'desc',
        },
        costs: [],
    },
    mutations: {
        save(state, data) {
            state.costs = data;
        },
        setPage(state, page) {
            state.page = page;
        },
        setSort(state, sort) {
            state.sort = sort;
        },
        resetState(state) {
            state.page = 1;
            state.costs = [];
        }
    },
    actions: {
        fetchCosts({ commit, dispatch }) {
            return fetchCosts()
                .then((res) => {
                    commit('save', res.data);

                    return Promise.resolve(res);
                })
                .catch((res) => {
                    dispatch('error', res, { root: true });

                    return Promise.reject(res);
                });
        },
        setPage({ commit }, page) {
            commit('setPage', page);
        },
        setSort({ commit }, sort) {
            commit('setSort', sort);
        },
        resetState({ commit }) {
            commit('resetState');
        }
    },
    getters: {
        totalRecords({ costs }) {
            return costs.length;
        },
        sortedRecords({ costs, sort }) {
            const sorted = costs.sort((a, b) => {
                return naturalCompare(
                    getTableValue(a, sort.column),
                    getTableValue(b, sort.column));
            });

            return sort.order === 'asc'
                ? sorted
                : sorted.reverse();
        },
        paginatedRecords({ page, display }, { sortedRecords }) {
            return sortedRecords.slice((page - 1) * display, page * display)
        },
    }
};



// WEBPACK FOOTER //
// ./src/modules/home/costs/store.js